// extracted by mini-css-extract-plugin
module.exports = {"madeby":"madeby_madeby__1FO4i"};